export function injectClientHighlightSpans(editor, matches, cssClass) {
  if (!matches || matches.length === 0) return;
  const doc = editor.getDoc();

  // Cap DOM highlights to a maximum of 50 per rule to avoid lag on 99+ matches
  const MAX_HIGHLIGHTS = 50;
  const visibleMatches = matches.slice(0, MAX_HIGHLIGHTS);

  const byNode = new Map();
  visibleMatches.forEach(m => {
    if (!byNode.has(m.node)) byNode.set(m.node, []);
    byNode.get(m.node).push(m);
  });

  byNode.forEach((nodeMatches, textNode) => {
    nodeMatches.sort((a, b) => b.start - a.start);
    nodeMatches.forEach(match => {
      if (match.processed) return;
      try {
        textNode.splitText(match.end);
        const middle = textNode.splitText(match.start);
        const span = doc.createElement("span");
        span.setAttribute("data-suggestion-uid", match.uid);
        span.setAttribute("data-suggestion-style", cssClass);
        if (match.styleId) span.setAttribute("data-styleId", match.styleId);
        span.setAttribute("contenteditable", "false");
        
        span.style.cssText = "background:rgba(255,200,0,0.3); border-bottom:2px dashed orange; cursor:pointer;";
        span.className = `client-style-highlight ${cssClass}`;

        middle.parentNode.insertBefore(span, middle);
        span.appendChild(middle);

        const zeroWidthSpace = doc.createTextNode("\u200B");
        span.parentNode.insertBefore(zeroWidthSpace, span.nextSibling);

        match.spanEl = span;
      } catch (e) {
        console.warn("client rule inject error:", e);
      }
    });
  });
}

// Find matches in specific elements (by tag name or selector)
export function findMatchesInSelector(editor, selector, styleId, pattern, styleName, suggestionGenerator) {
  const matches = [];
  const doc = editor.getDoc();
  const elements = doc.querySelectorAll(selector);

  elements.forEach(element => {
    const walker = doc.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          const parent = node.parentNode;
          if (!parent) return NodeFilter.FILTER_ACCEPT;
          if (parent.getAttribute?.("data-suggestion-uid")) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      },
      false
    );

    let node;
    while ((node = walker.nextNode())) {
      const text = node.nodeValue;
      let m;
      pattern.lastIndex = 0;
      while ((m = pattern.exec(text)) !== null) {
        const uid = `${styleId}-${Math.random().toString(36).slice(2, 9)}`;
        const originalText = m[0];
        const suggestedText = suggestionGenerator ? suggestionGenerator(m, text) : originalText;

        if (originalText === suggestedText) continue;

        matches.push({
          text: originalText,
          suggested: suggestedText,
          node,
          start: m.index,
          end: m.index + originalText.length,
          processed: false,
          name: styleName,
          styleId,
          uid
        });
      }
    }
  });

  return matches;
}
